import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

interface Props {
  headerHeight: number;
}

export default makeStyles<Theme, Props>(
  () =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        height: (props) => `calc(100vh - ${props.headerHeight}px)`,
        maxHeight: (props) => `calc(100vh - ${props.headerHeight}px)`,
        transition: 'height ease-out 0.3s',
        overflow: 'hidden',
      },
      content: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        overflow: 'hidden',
      },
      side: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      },
      left: {
        justifyContent: 'flex-start',
        width: '60%',
      },
      right: {
        width: '40%',
        borderLeftWidth: 1,
        borderLeftStyle: 'solid',
        borderLeftColor: sicrediColors.secondarySicrediLight,
      },
      loading: {
        width: '100%',
        position: 'fixed',
        top: (props) => props.headerHeight,
        left: 0,
        zIndex: 1200,
      },
    }),
  { name: 'MensagensAssessor' }
);
